import { render, staticRenderFns } from "./DefaultTextInput.vue?vue&type=template&id=3a560c34&scoped=true"
import script from "./DefaultTextInput.vue?vue&type=script&lang=js"
export * from "./DefaultTextInput.vue?vue&type=script&lang=js"
import style0 from "./DefaultTextInput.vue?vue&type=style&index=0&id=3a560c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a560c34",
  null
  
)

export default component.exports